import { createRouter, createWebHistory } from 'vue-router';
import store from '@baza/store';
import PrivacyPolicy from '@baza/components/lawModals/PrivacyPolicy.vue';
import PersonalData from '@baza/components/lawModals/PersonalData.vue';
import ContractOffer from '@baza/components/lawModals/ContractOffer.vue';
import RepairFormPage from '@baza/views/RepairFormPage.vue';
import MainComponent from '../views/Main.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: MainComponent,
        components: {
            default: MainComponent,
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/catalog/',
        name: 'catalog',
        components: {
            default: MainComponent,
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        components: {
            default: PrivacyPolicy,
        },
    },
    {
        path: '/personal-data',
        name: 'personal-data',
        components: {
            default: PersonalData,
        },
    },
    {
        path: '/contract-offer',
        name: 'contract-offer',
        components: {
            default: ContractOffer,
        },
    },
    {
        path: '/hiddenForm/2edse713o/:id',
        name: 'hiddenForm',
        components: {
            default: RepairFormPage,
        },
    },
    {
        path: '/catalog/:code/',
        name: 'catalog',
        components: {
            default: MainComponent,
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/catalog/:code/:id/',
        name: 'offer-detail',
        components: {
            default: () => import(/* webpackChunkName: "main" */ '../views/OfferDetail.vue'),
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/catalog/:code/:id/:landing',
        name: 'offer-landing',
        component: () => import(/* webpackChunkName: "main" */ '../views/LandingPage.vue'),
    },
    {
        path: '/catalog/:code/:id/zemsmirrors-optima-td',
        name: 'offer-landing-404',
        components: {
            default: () => import(/* webpackChunkName: "main" */ '../views/ErrorPage.vue'),
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/ui-board/',
        name: 'ui-board',
        component: () => import(/* webpackChunkName: "main" */ '../views/UiBoard.vue'),
    },
    {
        path: '/404page/',
        name: '404Page',
        components: {
            default: () => import(/* webpackChunkName: "main" */ '../views/ErrorPage.vue'),
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
    {
        path: '/:pathMatch(.*)*',
        components: {
            default: () => import(/* webpackChunkName: "main" */ '../views/ErrorPage.vue'),
            mobHeader: () => import('@baza/components/MainHeader.vue'),
            deskHeader: () => import ('@/components/ZemsdesignThreeColors/ZemsdesignHeader.vue'),
            footer: () => import('@baza/components/FooterBlock.vue'),
        },
    },
];

const router = createRouter({
    history: createWebHistory('/baza'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.name === 'catalog') {
            return store.state.isDesktop ? { el: '#scroll-block', top: 56 } : false;
        }
        return { top: 0 };
    },
});
router.beforeEach((to, from, next) => {
    // Store the route we're coming from in localStorage
    localStorage.setItem('previousRoute', from.name);
    next();
});

router.afterEach(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
});

export default router;
